import React, { FC, ReactElement } from "react";
import {
  JobsContainer,
  JobsCount,
  TableContainerBox,
  TableHeading,
  TableSubHeading,
} from "../styles";
import ApplyButton from "../ApplyButton";
import {
  SearchContainer,
  SearchInput,
  HorizontalLine,
  JobList,
  JobItem,
  Separator,
  SearchIcon,
  NoResults,
} from "./styles";
import { LoadMore, Flex } from "../ApplyButton/styles";
import { Loader } from "../Loader";
import { seachIconSrc } from "../constant";

interface IProps {
  searchData: (param: string) => void;
  loadMoreJobs: () => void;
  noResults: boolean;
  visibleJobs: number;
  jobData: Array<{ jobTitle: string; applyUrl: string }>;
  isLoading: boolean;
  error: any;
}

const Jobs: FC<IProps> = ({
  searchData,
  loadMoreJobs,
  noResults,
  visibleJobs,
  jobData,
  isLoading = false,
  error = null,
}): ReactElement => {
  return (
    <JobsContainer>
      <JobsCount>{jobData.length || 0} jobs found</JobsCount>

      <SearchContainer>
        <SearchIcon src={seachIconSrc} />
        <SearchInput
          type="text"
          placeholder="Search by role/tech skills (Eg. SDE 1, Eng manager...)"
          onChange={(e) => searchData(e.target.value)}
        />
      </SearchContainer>

      <TableContainerBox>
        <TableHeading>Recent open positions</TableHeading>
        {!noResults && <TableSubHeading>Job Title</TableSubHeading>}

        <HorizontalLine />

        {isLoading && <Loader />}

        {error && <div>Error loading jobs.</div>}

        <JobList>
          {noResults ? (
            <NoResults>No jobs found.</NoResults>
          ) : (
            jobData.slice(0, visibleJobs).map((job, index) => (
              <React.Fragment key={index}>
                <JobItem highlighted={index % 2 !== 0}>
                  <span>{job.jobTitle}</span>
                  <ApplyButton title="Apply Now" url={job.applyUrl} />
                </JobItem>
                {index < jobData.length && <Separator />}
              </React.Fragment>
            ))
          )}
        </JobList>

        {!noResults && visibleJobs < jobData.length && (
          <Flex>
            <LoadMore onClick={loadMoreJobs}>Load More</LoadMore>
          </Flex>
        )}
      </TableContainerBox>
    </JobsContainer>
  );
};

export default Jobs;
